/**
 * 微信公众号相关逻辑代码
 */
import { WechatAuthOptions, WechatUserInfoOptions } from './types/WehatAccountTypes'
import { getWechatAuthUrl, getWechatUserInfoService } from './services/wechatAccountService'
import { isWeixinClient } from '../tools/utils'

/**
 * 佣金宝公众号授权
 */
const wechatAuth = async (options: WechatAuthOptions) => {
  if (!isWeixinClient()) {
    return {
      code: '400400',
      msg: '请在微信客户端中打开!'
    }
  }

  const { scope, redirect_uri, account_name, app_name, ...last } = options

  // 拼接参数，含默认参数
  const params = {
    ...last,
    app_name: app_name || 'yjb',
    scope: scope || 'snsapi_base',
    account_name: account_name || 'gjzq',
    redirect_uri: redirect_uri || location.href
  }

  // TODO 需优化场景：用户授权后不需要刷新页面
  try {
    const { code, result } = await getWechatAuthUrl(params)
    if (code === 0) {
      // 优化支付跳转交互
      window.location.replace(result)
    } else {
      return {
        code: 500,
        msg: '获取授权链接失败'
      }
    }
  } catch (error) {
    return {
      code: 500,
      msg: '获取授权链接失败'
    }
  }
}

/**
 * 获取微信用户信息
 */
const getWechatUserInfo = async (options: WechatUserInfoOptions) => {
  if (!isWeixinClient()) {
    return {
      code: '400400',
      msg: '请在微信客户端中打开!'
    }
  }
  if (!options || (options && !options.code)) {
    return {
      code: '400400',
      msg: 'code 不能为空'
    }
  }

  options.account_name = options.account_name ? options.account_name : 'gjzq'
  options.app_name = options.app_name ? options.app_name : 'yjb'

  try {
    const result: any = await getWechatUserInfoService(options)
    return result
  } catch (error) {
    return {
      code: 500,
      msg: '获取用户信息失败'
    }
  }
}

export default {
  wechatAuth,
  getWechatUserInfo
}
